import { page } from '@/api/base/baseCurrency'
import optionsMixin from '../mixins/optionsMixin'

export default optionsMixin(page)
